class SearchTermTileListUpdaterController {
    $onChanges(changes) {
        if (changes.searchTerm && !changes.searchTerm.isFirstChange()) {
            this.tileList.update();
        }
    }
}

/**
 * @ngdoc component
 * @name wowSearchTermTileListUpdater
 *
 * This component is transcluded into tile list for the purpose of updating
 * the products whenever the search term is changed.
 *
 * This is not useful for the search page itself since changing the search
 * term causes a reload there - this is intended for use in lists when doing
 * free text tags search. Therefore this component is not needed for recipe
 * or inspiration search since those searches are not performed outside of search.
 */
const searchTermTileListUpdaterComponentDefinition = {
    bindings: {
        searchTerm: '<',
    },
    require: {
        tileList: '^wowTileList',
    },
    controller: SearchTermTileListUpdaterController,
};

module.exports = {
    SearchTermTileListUpdaterController,
    searchTermTileListUpdaterComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/search/search-term-tile-list-updater.component.js